import {
  ButtonBase,
  FormControl,
  Typography,
  InputLabel as BaseInputLabel,
  styled,
} from '@material-ui/core'
import { Icon as BaseIcon } from '@iconify/react'
import { WrapperProps, TitleProps, InputLabelProps } from './Select.types'

export const POPPER_Z_INDEX = 99

const WRAPPER_HEIGHT = 32
const WRAPPER_RADIUS = 10
const ICON_WRAPPER_WIDTH = 30
const ICON_MIN_WIDTH = 15

export const Wrapper = styled(ButtonBase)(
  ({ theme, isOpen, isError }: WrapperProps) => ({
    color: theme.palette.common.black,
    transition: 'border-color .3s',
    border: `1px solid ${
      isError
        ? theme.palette.error.main
        : isOpen
        ? theme.palette.primary.main
        : theme.palette.text.disabled
    }`,
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
    height: WRAPPER_HEIGHT,
    borderRadius: WRAPPER_RADIUS,
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    '& span': {
      fontSize: 12,
      lineHeight: '14px',
      color: theme.palette.text.disabled,
      textTransform: 'none',
      width: '100%',
    },
    '& > div': {
      width: '100%',
    },
    ...(isError ? { backgroundColor: theme.palette.error.light } : {}),
  })
)

export const Container = styled(FormControl)({
  '& > div': {
    minWidth: '100%',
  },
})

export const InputLabel = styled(BaseInputLabel)(
  ({ theme, isError }: InputLabelProps) => ({
    color: isError ? theme.palette.error.main : theme.palette.primary.main,
  })
)

export const Title = styled(Typography)(
  ({ theme, isPlaceholder, isError }: TitleProps) => ({
    flexBasis: `calc(100% - ${ICON_WRAPPER_WIDTH}px)`,
    overflow: 'hidden',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    paddingLeft: theme.spacing(1.5),
    color: isError
      ? theme.palette.error.main
      : isPlaceholder
      ? theme.palette.text.disabled
      : theme.palette.common.black,
  })
)

export const Icon = styled(BaseIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  minWidth: ICON_MIN_WIDTH,
  transition: 'all .3s',
}))
